import { setViewport } from './clickListener'
let viewports = [
  {
    label: 'Mobile',
    value: 500
  },
  {
    label: 'Tablet',
    value: 992
  },
  {
    label: 'Desktop',
    value: 99999
  }
]

/** @type {string | null} */
let currentViewport = null

/**
 * @param {Viewport[] | null} customViewports
 * @returns {TeardownFunction}
 */
export default (customViewports = null) => {
  if (customViewports) viewports = customViewports
  viewports = sortArray(viewports)

  handleResize()
  window.addEventListener('resize', handleResize)

  return () => {
    window.removeEventListener('resize', handleResize)
  }
}

/**
 * @param {Viewport[]} values 
 * @returns {Viewport[]}
 */
const sortArray = values => values.sort((a,b) => b.value - a.value)

const handleResize = () => {
  let newViewport = null
  viewports.map(viewport => {
    const { label, value } = viewport
    if (document.body.clientWidth < value) newViewport = label
  })

  if ( newViewport !== currentViewport) {
    currentViewport = newViewport
    setViewport(currentViewport)
  }
}

export const getViewport = () => currentViewport

/**
 * @typedef {object} Viewport
 * @prop {string} label
 * @prop {number} value
 */
